import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "How do I know my size?", a: "Every product page includes a size guide with detailed measurements. If you're between sizes, we recommend sizing up for slip and column silhouettes." },
  { q: "When will my order ship?", a: "Orders placed before 2pm IST ship the same day. In-stock pieces are delivered within 3–6 business days across India." },
  { q: "Is shipping free?", a: "Yes — shipping is complimentary on all orders above ₹999 within India." },
  { q: "Can I return or exchange my order?", a: "Yes. We accept returns and exchanges within 7 days of delivery, on unworn pieces with tags intact. Sale items are eligible for exchange only." },
  { q: "Do you ship internationally?", a: "Not yet. We're a small studio and currently ship within India only. International shipping is on our roadmap for late 2026." },
  { q: "How do I care for my Vastra West pieces?", a: "Silk and viscose crepe pieces are dry clean only. Linen and cotton pieces can be machine-washed cold and hung to dry. Care instructions are printed on every garment." },
];

const FAQ = () => (
  <div data-testid="faq-page" className="max-w-3xl mx-auto px-6 py-16 md:py-24">
    <p className="overline text-[color:var(--vw-ink-soft)]">Answers</p>
    <h1 className="font-serif-display text-5xl md:text-7xl italic mt-3">FAQ</h1>

    <Accordion type="single" collapsible className="mt-12">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-b border-[color:var(--vw-beige)]">
          <AccordionTrigger data-testid={`faq-q-${i}`} className="font-serif-display text-xl md:text-2xl text-left hover:no-underline py-6">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-[color:var(--vw-ink-soft)] leading-relaxed pb-6">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);

export default FAQ;
